import Busy from "components/layout/overlay/components/Busy";

interface MapLoaderControlProps {
    show: boolean
}
export const MapLoaderControl = ({
    show
}: MapLoaderControlProps) => {
    return (
        show &&
        <div>
            <Busy isBusy={show} size="medium" type="infinite-spinner"/>
        </div>

    );
}
